import Vue from 'vue'
import axios from 'axios'
import { Dialog, Toast } from 'vant';
Vue.prototype.$axios = axios
axios.defaults.timeout = 60000

// if (process.env.NODE_ENV !== 'development') {
  //开发环境下的代理地址，解决本地跨域跨域，配置在config目录下的index.js dev.proxyTable中
  // axios.defaults.baseURL = 'https://qmlgtest.fzrykj.com/'  //测试
  axios.defaults.baseURL = 'https://case.chinawans.com/'  //正式
// }

axios.interceptors.request.use(
  config => {
    let token = '';
    if (token) {
      config.headers['token'] = String(token);
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  })

axios.interceptors.response.use(
  response => {  //成功请求到数据
    // //这里根据后端提供的数据进行对应的处理
    if (response.data.code == 200) {
      return response
    } else if (response.data.code == 500) {
      Dialog.alert({
        title: '提示',
        message: response.data.message
      })
      return Promise.reject(response);
    } else if (response.data.code == 400) {
      Dialog.alert({
        title: '提示',
        message: response.data.message
      })
      return Promise.reject(response);
    }else {
      return Promise.reject(response);
    }
  },
  error => {  //响应错误处理
    Toast.clear()
    Dialog.alert({
      title: '提示',
      message: '请求超时'
    })
    return Promise.reject(error)
  }
)




